import { render, staticRenderFns } from "./CommonSwiper.vue?vue&type=template&id=ca344dce&scoped=true"
import script from "./CommonSwiper.vue?vue&type=script&lang=js"
export * from "./CommonSwiper.vue?vue&type=script&lang=js"
import style0 from "./CommonSwiper.vue?vue&type=style&index=0&id=ca344dce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca344dce",
  null
  
)

export default component.exports